export default __webpack_public_path__ + "static/avatar-02fd096940848951f5dfc8f2b9679154.jpeg";